export default __webpack_public_path__ + "static/FunnyWeather-e530a775083ff5554347337baebf3b3b.png";